export default __webpack_public_path__ + "static/media/Annons 1.7a17f19e.jpg";